import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useConfirm } from '@/hooks/use-confirm';
import { ordersService } from '@/services/orders.service';
import { errorMessage } from '@/lib/api';
import { qk } from '@/lib/query-keys';
import type { MaintenanceEntry } from '@/types/api';

export function MaintenanceDeleteButton({ orderId, entry }: { orderId: string; entry: MaintenanceEntry }) {
  const confirm = useConfirm();
  const qc = useQueryClient();
  const remove = useMutation({
    mutationFn: () => ordersService.removeMaintenance(orderId, entry.id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.orders.detail(orderId) });
      void qc.invalidateQueries({ queryKey: qk.clients.all });
      void qc.invalidateQueries({ queryKey: qk.equipment.all });
      toast.success('Registro excluído do histórico.');
    },
    onError: (err) => toast.error(errorMessage(err)),
  });
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className="hover:text-destructive"
      title="Excluir registro e seus anexos"
      loading={remove.isPending}
      aria-label={`Excluir serviço: ${entry.description}`}
      onClick={async () => {
        if (
          await confirm({
            title: 'Excluir registro do histórico?',
            description: `O comentário “${entry.description}” e seus anexos serão excluídos permanentemente. Essa ação não pode ser desfeita.`,
            confirmText: 'Excluir registro',
            destructive: true,
          })
        )
          remove.mutate();
      }}
    >
      <Trash2 aria-hidden />
    </Button>
  );
}
